import React, { Fragment } from "react";
import { Row, Col, Accordion } from "react-bootstrap";
import Iram from "../../assets/Iram.png";
import IpcCalidad from "../../assets/IpcCalidad.png";
import Star from "../../assets/star.png";

const RazonSeis = () => {
  return (
    <Fragment>
      <Col
        lg={8}
        className="contentCards cardLigth "
        id="razonSeis"
        data-aos="zoom-in"
        data-aos-offset="300"
        data-aos-duration="1000"
        data-aos-easing="ease-out"
      >
        <h4>Razón #6</h4>
        <h2
          data-aos="fade-right"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          Calidad
        </h2>

        <p
          data-aos="fade-right"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          Pioneros en certificar gestión de calidad bajo la norma ISO 9001:2015.
          Respaldo del sello de calidad de IPC Pools.
        </p>

        <p
          data-aos="fade-right"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Ver Norma </Accordion.Header>
              <Accordion.Body>
                <p className="textoCalidad">
                  Comprometidos con nuestra política de calidad y conscientes de
                  la importancia del cumplimiento de la misma, IPC Pools pone de
                  relieve los valores Innovación, Pasión y Compromiso que
                  distinguen a la organización.
                </p>
                <p className="textoCalidad">
                  Estamos orgullosos del grupo humano que hace posible el logro
                  de los objetivos en la satisfacción del cliente, la mejora
                  continua de los productos y procesos, y la responsabilidad que
                  asumen cada día frente a los desafíos internos y externos.
                  Desde que certificamos el sistema de gestión de la calidad
                  bajo la Norma ISO 9001:2015, la empresa ha multiplicado el
                  impacto del esfuerzo, dedicación y trabajo colaborativo de su
                  capital humano, ha incorporado los recursos y la tecnología
                  para mantener su liderazgo en el mercado. La calidad es cosa
                  de todos los días porque todos somos calidad en IPC.
                </p>
                <div className="imgCalidad">
                  <img
                    src={Iram}
                    alt="Calidad"
                    className="img-fluid"
                    data-aos="fade-up"
                    data-aos-offset="200"
                    data-aos-duration="1000"
                    data-aos-easing="ease-out"
                  ></img>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </p>
        <Row>
          <Col lg={3}>
            <img
              src={IpcCalidad}
              alt="Calidad"
              className="img-fluid calidad"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="1000"
              data-aos-easing="ease-out"
            ></img>
          </Col>
          <Col lg={9} className="contentStars">
            <img
              src={Star}
              className="star"
              alt="Calidad"
              data-aos="flip-up"
              data-aos-offset="0"
              data-aos-duration="1000"
              data-aos-easing="ease-out"
            ></img>
            <img
              src={Star}
              className="star"
              alt="Calidad"
              data-aos="flip-up"
              data-aos-offset="50"
              data-aos-duration="2000"
              data-aos-easing="ease-out"
            ></img>
            <img
              src={Star}
              className="star"
              alt="Calidad"
              data-aos="flip-up"
              data-aos-offset="100"
              data-aos-duration="3000"
              data-aos-easing="ease-out"
            ></img>
            <img
              src={Star}
              className="star"
              alt="Calidad"
              data-aos="flip-up"
              data-aos-offset="150"
              data-aos-duration="3000"
              data-aos-easing="ease-out"
            ></img>
            <img
              src={Star}
              className="star"
              alt="Calidad"
              data-aos="flip-up"
              data-aos-offset="200"
              data-aos-duration="3000"
              data-aos-easing="ease-out"
            ></img>
          </Col>
        </Row>
      </Col>
    </Fragment>
  );
};

export default RazonSeis;
